import { compose, equals, find, head, lensPath, pathOr, set, when } from 'ramda';
import store from 'src/store';
import { ADVISOR_REDUX_RESOURCE_NAME, REDUX_ASSETS, REDUX_COLLATERAL, REDUX_LOANAPP, USER_REDUX_RESOURCE_NAME } from 'src/store/constants';
import {
  getActiveBorrowerAccount,
  getItemsByIdResources,
  getItemsByIdResourcesWithActiveLoanId,
  getItemsByIdResourcesWithActiveLoanRole,
  getItemsResourcesData,
} from 'src/store/store.helpers';
import { getEmployments } from 'src/store/employment/employment.selector';
import { getEmployment as _describeEmployments } from 'src/store/employment/employment.requests';
import { isNotEmpty } from 'src/utilities/hasValue';
import { getEmploymentBySession } from 'src/store/employment/employment.sessions';
import { getLendingTermBySession } from 'src/store/lendingTerms/lendingterms.sessions';
import { Storage, currentAppSession, storage } from 'src/utilities/storage';
import { getBusinessBySession } from 'src/store/business/businessBySession';
import { notHasWorkflowLoanActive } from 'src/features/utilities';
import { getTheBorrower, getTheCoBorrower } from 'src/utilities/borrowers';
import {
  REDUX_BORROWERS,
  REDUX_APPLICANT_ACCOUNTS,
  REDUX_DECLARATIONS,
  REDUX_BUSINESS,
  REDUX_LENDING_TERMS,
  REDUX_PROPERTY,
  REDUX_LOANAPPROLES,
  REDUX_EMPLOYMENTS,
  REDUX_WORKFLOW_INTENTS,
  REDUX_REAL_ESTATE_ASSETS,
  REDUX_LOAN_STATUS,
  REDUX_MONTHLY_INCOMES,
  REDUX_ADDITIONAL_LOANS,
  REDUX_LIABILITIES
} from 'src/store/constants';
import { getMonthlyIncomeBySession } from 'src/store/monthlyIncome/monthlyIncome.sessions';
import { getRealEstateAssetBySession } from 'src/store/realEstateAssets/realEstateAssets.sessions';
import { getpropertyBySession } from 'src/store/properties/properties.sessions';
import { getAssetsBySession } from 'src/store/assets/assets.sessions';
import { ResourceFinder } from '../../Intents/ApiContext/resourceFinder';
import { mkObject } from 'src/services/objects/build';
import {
  API_RESOURCE_USER_ACCOUNTS,
  API_RESOURCE_EMPLOYMENTS,
  API_RESOURCE_MONTHLY_INCOMES,
  API_RESOURCE_REAL_ESTATE_ASSET,
  API_RESOURCE_LIABILITIES,
  API_RESOURCE_ASSETS,
  API_RESOURCE_ADDITIONAL_LOAN,
  API_RESOURCE_BUSINESS,
  API_RESOURCE_LENDING_TERMS,
  API_RESOURCE_PROPERTIES,
  API_RESOURCE_LOAN_STATUS,
  API_RESOURCE_BORROWERS,
  API_RESOURCE_DECLARATIONS,
  API_RESOURCE_LOANAPP_ROLES,
  API_RESOURCE_WORKFLOW_INTENTS,
  API_RESOURCE_COLLATERAL,
  OBJECT_META,
  LABELS,
  YES_UPPERCASE_Y,
  USER_WORKFLOW_INTENT
} from 'src/services/constants';
import { getCollateralBySession } from 'src/store/collateral/collateral.sessions';
import { getLiabilitiesBySession } from 'src/store/liabilities/liabilities.sessions';
import { getDeclarationsBySession } from 'src/store/declaration/declaration.sessions';
import { getBorrowersBySession } from 'src/store/borrower/borrower.sessions';
import { getUserSpecificIntentBySession } from 'src/store/siteConfigurator/userSpecificIntent/userSpecificIntent.sessions';

// TODO: have to change the names like api resource names 
export interface ISessionStore {
  session: Storage;
  employments: any;
  lendingTerm: any;
  property: any;
  monthlyIncomes: any;
  realEstateAssets: any;
  business: any;
  assets: any;
  collateral: any;
  declaration: any;
  borrower: any;
  liabilities: any;
  workflowIntent: any;
}

export interface StateStore {
  getStateFromStore: any;
  findResource: any;
  mutateStateStoreFn?: () => void;
}

export class ReduxStateStore implements StateStore {
  singleSiteIntent: any;
  mockState?: any;
  state: any;

  constructor(singleSiteIntent: any, mockState?: any) {
    this.singleSiteIntent = singleSiteIntent;
    this.state = store.getState();
    this.mockState = mockState;
  }

  getStateFromStore() {
    return isNotEmpty(this.getMockState())
      ? this.getMockState()
      : this.getStateFromReduxStore();
  }

  getMockState() {
    return this.mockState;
  }

  findResource(resourceFinder: any, apiResourceName: any) {
    return new ResourceFinder().getResource(
      resourceFinder,
      this.getStateFromStore(),
      apiResourceName
    );
  }

  // TODO: once we get using only one model to pull loan data we can get rid of this function 
  // This method is used to for redux loan resources into core api loan app spec schema 
  coreLoanSpec() {
    const {
      property,
      lendingTerm
    } = this.getStateFromReduxStore()

    const { loanAppId } = currentAppSession()
    const loanAppFromReducer = getItemsResourcesData(REDUX_LOANAPP, this.state);
    const applicationNumber = pathOr("", ["application_number"], loanAppFromReducer);
    const createdAt = pathOr("", ["created_at"], loanAppFromReducer);


    const loanApp = {
      id: loanAppId,
      object_meta: mkObject('store-loanapp'),
      ...loanAppFromReducer,
      spec: {
        [API_RESOURCE_USER_ACCOUNTS]: getItemsByIdResources(REDUX_APPLICANT_ACCOUNTS, this.state),
        [API_RESOURCE_BORROWERS]: getItemsByIdResources(REDUX_BORROWERS, this.state),
        [API_RESOURCE_BUSINESS]: [pathOr({}, [USER_REDUX_RESOURCE_NAME, REDUX_BUSINESS, 'data'], this.state)],
        [API_RESOURCE_EMPLOYMENTS]: getItemsByIdResources(REDUX_EMPLOYMENTS, this.state),
        [API_RESOURCE_DECLARATIONS]: getItemsByIdResources(REDUX_DECLARATIONS, this.state),
        [API_RESOURCE_COLLATERAL]: getItemsByIdResources(REDUX_COLLATERAL, this.state),
        [API_RESOURCE_LIABILITIES]: getItemsByIdResources(REDUX_LIABILITIES, this.state),
        [API_RESOURCE_ASSETS]: getItemsByIdResources(REDUX_ASSETS, this.state),
        [API_RESOURCE_ADDITIONAL_LOAN]: getItemsByIdResources(REDUX_ADDITIONAL_LOANS, this.state),
        [API_RESOURCE_REAL_ESTATE_ASSET]: getItemsByIdResources(REDUX_REAL_ESTATE_ASSETS, this.state),
        [API_RESOURCE_MONTHLY_INCOMES]: getItemsByIdResources(REDUX_MONTHLY_INCOMES, this.state),
        [API_RESOURCE_LOAN_STATUS]: pathOr([{}], [USER_REDUX_RESOURCE_NAME, REDUX_LOAN_STATUS, 'data', 'items'], this.state),
        [API_RESOURCE_LENDING_TERMS]: lendingTerm,
        [API_RESOURCE_LOANAPP_ROLES]: getItemsByIdResources(REDUX_LOANAPPROLES, this.state),
        workflow_intents: getItemsByIdResources(REDUX_WORKFLOW_INTENTS, this.state),
        [API_RESOURCE_PROPERTIES]: property,
      }
    }
    return compose(
      when(
        () => isNotEmpty(applicationNumber),
        set(lensPath(['application_number']), applicationNumber),
      ),
      when(
        () => isNotEmpty(createdAt),
        set(lensPath(['created_at']), createdAt),
      )
    )(loanApp)


  }

  private getStateFromReduxStore() {
    const updatePwd = compose(set(lensPath(['password']), '   '));
    const borrowerAccount = getActiveBorrowerAccount(this.state);

  const userSpecificIntent = pathOr({}, [0], getItemsByIdResourcesWithActiveLoanRole(USER_WORKFLOW_INTENT, this.state))
  const userSpecificIntents = getItemsByIdResources(USER_WORKFLOW_INTENT, this.state);

    const declarations = head(
      getItemsByIdResourcesWithActiveLoanRole(REDUX_DECLARATIONS, this.state)
    )
    return {
      session: storage,
      accounts: updatePwd(borrowerAccount),
      loanapps: pathOr(
        {},
        [USER_REDUX_RESOURCE_NAME, REDUX_LOANAPP, 'data'],
        this.state
      ),
      business: pathOr(
        {},
        [USER_REDUX_RESOURCE_NAME, REDUX_BUSINESS, 'data'],
        this.state
      ),
      employment: getEmployments(
        getItemsByIdResourcesWithActiveLoanRole(REDUX_EMPLOYMENTS, this.state),
        this.singleSiteIntent
      ),
      employments: getItemsByIdResourcesWithActiveLoanRole(
        REDUX_EMPLOYMENTS,
        this.state
      ),
      collateral: getItemsByIdResourcesWithActiveLoanRole(
        REDUX_COLLATERAL,
        this.state
      ),
      borrower: head(
        getItemsByIdResourcesWithActiveLoanRole(REDUX_BORROWERS, this.state)
      ),
      [API_RESOURCE_DECLARATIONS]: declarations,
      declaration: declarations,
      monthlyIncome: head(
        getItemsByIdResourcesWithActiveLoanRole(REDUX_MONTHLY_INCOMES, this.state)
      ),
      monthlyIncomes: getItemsByIdResourcesWithActiveLoanRole(REDUX_MONTHLY_INCOMES, this.state),
      realEstateAssets: getItemsByIdResourcesWithActiveLoanRole(REDUX_REAL_ESTATE_ASSETS, this.state),
      assets: getItemsByIdResourcesWithActiveLoanRole(REDUX_ASSETS, this.state),
      liabilities: 
        getItemsByIdResourcesWithActiveLoanRole(REDUX_LIABILITIES, this.state)
      ,
      lendingTerm: head(
        getItemsByIdResourcesWithActiveLoanId(REDUX_LENDING_TERMS, this.state)
      ),
      borrowerLoanRole: getTheBorrower(
        getItemsByIdResources(REDUX_LOANAPPROLES, this.state)
      ),
      coBorrowerLoanRole: head(getTheCoBorrower(
        getItemsByIdResources(REDUX_LOANAPPROLES, this.state)
      )),
      coBorrowerName: head(getTheCoBorrower(
        getItemsByIdResources(REDUX_BORROWERS, this.state)
      )),
      property: head(
        getItemsByIdResourcesWithActiveLoanId(REDUX_PROPERTY, this.state)
      ),
      primary_collateral: find((item: any) => equals(YES_UPPERCASE_Y, pathOr('', [OBJECT_META, LABELS, 'is_primary'], item)), getItemsByIdResourcesWithActiveLoanRole(
        REDUX_COLLATERAL,
        this.state
      )),
      advisorResource: pathOr({}, [ADVISOR_REDUX_RESOURCE_NAME,"advisorProfile","data"],this.state),
      userSpecificIntent,
      loanUsersSpecificIntents: userSpecificIntents,
    };
  }

  mutateStoreFn: () => {};
}

export class SessionStateStore implements StateStore {
  state: {};
  mockState: any;
  // TODO: inside code we should not use mock we have to add mock on test files for the store.
  // So when we get store.getState() we should return our mock state 
  constructor(mockState?: any) {
    this.state = store.getState();
    this.mockState = mockState;
  }

  findResource(resourceFinder: any, apiResourceName: any) {
    return new ResourceFinder().getResource(
      resourceFinder,
      this.getStateFromStore(),
      apiResourceName
    );
  }
  getMockState() {
    return this.mockState;
  }

  getStateFromStore() {
    return isNotEmpty(this.getMockState())
      ? this.getMockState()
      : this.getStateFromSessionStore();
  }

  coreLoanSpec() {
    return {
      spec: {
        [API_RESOURCE_EMPLOYMENTS]: getEmploymentBySession(),
        [API_RESOURCE_MONTHLY_INCOMES]: getMonthlyIncomeBySession(),
        [API_RESOURCE_REAL_ESTATE_ASSET]: getRealEstateAssetBySession(),
        [API_RESOURCE_BUSINESS]: [getBusinessBySession()],
        [API_RESOURCE_BORROWERS]: pathOr([], ['data', 'items'], getBorrowersBySession()),
        [API_RESOURCE_LENDING_TERMS]: getLendingTermBySession(),
        [API_RESOURCE_PROPERTIES]: getpropertyBySession(),
        [API_RESOURCE_ASSETS]: getAssetsBySession(),
        [API_RESOURCE_DECLARATIONS]: getDeclarationsBySession(),
        [API_RESOURCE_LIABILITIES]: getLiabilitiesBySession(),
        [API_RESOURCE_WORKFLOW_INTENTS]: [getUserSpecificIntentBySession()],
        [API_RESOURCE_COLLATERAL]: getCollateralBySession(),
        [API_RESOURCE_USER_ACCOUNTS]: []
      }
    }
  }

  private getStateFromSessionStore(): ISessionStore {
    return {
      session: storage,
      employments: getEmploymentBySession(),
      monthlyIncomes: getMonthlyIncomeBySession(),
      realEstateAssets: getRealEstateAssetBySession(),
      business: getBusinessBySession(),
      lendingTerm: getLendingTermBySession(),
      property: getpropertyBySession(),
      assets: getAssetsBySession(),
      collateral: getCollateralBySession(),
      declaration: getDeclarationsBySession(),
      [API_RESOURCE_LIABILITIES]: getLiabilitiesBySession(),
      borrower: getBorrowersBySession(),
      workflowIntent: getUserSpecificIntentBySession()
    };
  }
}


export const getStoreBasedOnAuthenticationType = () => {
  return notHasWorkflowLoanActive() ? SessionStateStore : ReduxStateStore;
};
